export default __webpack_public_path__ + "static/media/rewards-comp-mobile.20d50da7.png";